import request from '@/utils/request'

// 获取配置
export const config = (params) => {
    return request.get('/config', { params })
}

/** 获取直注音标 */
export const specialSoundmark = (params) => {
    return request.get('/course-vocabulary/special-soundmark', { params })
};
